import { Objects as ObjectsActionTypes } from '@src/redux/actionTypes'
import {
  defaultState as defaultDetailsState,
  ObjectDetailsState
} from '../../reducers/objects/details/default.state'
import {
  ObjectItem,
  defaultState as defaultSummaryState,
  ObjectsState
} from '../../reducers/objects/summary/default.state'
import * as ReduxHelpers from '@src/utils/reduxHelpers'
import type { ObjectDetailInfo } from '@src/endpoints/services/graphQueryMgr.service'
import type { Graph } from '@src/components/vis.js.network.vis/models'
import type { InfoDetailsResult } from '@src/utils/resource.utils'

export const changeSummaryState = ReduxHelpers.Common.Actions.changeState(
  ObjectsActionTypes.CHANGE_STATE,
  defaultSummaryState
)

export const changeDetailsState = ReduxHelpers.Common.Actions.changeState(
  ObjectsActionTypes.CHANGE_DETAILS_STATE,
  defaultDetailsState
)

export const cleanerStat = ReduxHelpers.Common.Actions.cleanerState(
  ObjectsActionTypes.CLEANER_STAT,
  defaultDetailsState
)

export const disposeDetails = () =>
  ReduxHelpers.Actions.createAction(ObjectsActionTypes.DISPOSE_DETAILS)

export const getGraphSuccess = (graph?: Graph) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.GET_OBJECT_DETAILS_GRAPH_DATA,
    { graph }
  )

export const getTableSuccess = (table, selectedTile) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.GET_OBJECT_DETAILS_TABLE_DATA,
    { table, selectedTile }
  )

export const summaryErrors = (stateProps?: Partial<ObjectsState>) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.SUMMARY_SERVER_ERRORS,
    {
      stateProps,
      isPending: false
    }
  )

export const detailsErrors = (stateProps?: Partial<ObjectDetailsState>) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.DETAILS_SERVER_ERRORS,
    {
      stateProps,
      isPending: false
    }
  )

export const requestPending = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(ObjectsActionTypes.REQUEST_PENDING, {
    isPending
  })

export const requestPendingGraph = (isPending: boolean) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.REQUEST_PENDING_GRAPH,
    {
      isPending
    }
  )

export const getOverviewStatsSuccess = (
  list: ObjectItem[],
  isPending = false
) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.GET_OBJECTS_OVERVIEW_STATS_DATA,
    {
      list,
      isPending
    }
  )

export const getDetailsStatsData = (
  data: ObjectDetailInfo,
  objectInfo: InfoDetailsResult,
  isPending = false
) =>
  ReduxHelpers.Actions.createPayloadAction(
    ObjectsActionTypes.GET_OBJECT_DETAILS_STATS_DATA,
    {
      data,
      objectInfo,
      isPending
    }
  )
